import { useController } from "react-hook-form";
import { Language } from "../beheer/components/TranslatableEditor/translations_definitions";
import { JamezzLanguage } from "../beheer/variables/app";
import { useSalesareaCtx } from "../beheer/views/Upsell/modernTS/salesarea/SalesareaContext";

export function useSelectedBackofficeLanguages(defaultLanguage: Language): Language[] {
  const {
    field: { value: selectedLanguages },
  } = useController({ name: "extra_settings__showLangselLanguages" });

  const {
    field: { value: selectedLanguages2 },
  } = useController({ name: "vestiging.extra_settings.showLangselLanguages" });

  const s = useSalesareaCtx();

  if (s.extra_settings.showLangselLanguages && s.extra_settings.showLangselLanguages.length) {
    return s.extra_settings.showLangselLanguages;
  }
  if (selectedLanguages) {
    return JSON.parse(selectedLanguages);
  }
  if (selectedLanguages2) {
    return JSON.parse(selectedLanguages2);
  }
  return [defaultLanguage];
}

export function useApplicationDefaultLanguage(): JamezzLanguage {
  const {
    field: { value: selectedDefaultLanguage },
  } = useController({ name: "mainLanguage" });

  const {
    field: { value: selectedDefaultLanguageVestiging },
  } = useController({ name: "vestiging.mainLanguage" });
  const s = useSalesareaCtx();

  if (s.mainLanguage) {
    return s.mainLanguage;
  }

  return selectedDefaultLanguage?.toLowerCase() ?? selectedDefaultLanguageVestiging?.toLowerCase() ?? "en";
}
